import "./OrientationSelectionGroup.css";

const OrientationSelectionGroup = ({
  selectedOrientation,
  handleOrientationChange,
}) => {
  return (
    <div className="ButtonGroup__container">
      <button
        className={`ButtonGroup__button ${selectedOrientation === "Std" ? "active" : ""}`}
        onClick={() => handleOrientationChange("Std")}
      >
        Standard
      </button>
      <button
        className={`ButtonGroup__button ${selectedOrientation === "Rev" ? "active" : ""}`}
        onClick={() => handleOrientationChange("Rev")}
      >
        Mirrored
      </button>
    </div>
  );
};

export default OrientationSelectionGroup;
